import { cn } from "~/lib/utils";

import { SidebarMenuSub } from "../ui/sidebar";
import { Skeleton } from "../ui/skeleton";

/** Widths cycle rather than randomize, so the ghost renders the same on every pass. */
const PROJECT_GHOSTS = [
  { key: "first", name: "w-28", threads: ["w-4/5", "w-3/5", "w-2/3"] },
  { key: "second", name: "w-20", threads: ["w-3/5", "w-4/5"] },
] as const;

/**
 * The project list's own shape while an Environment has not delivered its first snapshot:
 * project rows over indented thread rows, at the real rows' heights. Standing in for the
 * list keeps "still synchronizing" from reading as an empty Host Store.
 */
export function SidebarProjectsGhost() {
  return (
    <div
      role="status"
      aria-label="Synchronizing projects"
      className="flex flex-col gap-1 motion-safe:animate-skeleton"
    >
      {PROJECT_GHOSTS.map((project) => (
        <div key={project.key}>
          <div className="flex h-8 items-center gap-2 p-2">
            <Skeleton className="size-4 rounded-md" />
            <Skeleton className={cn("h-3.5", project.name)} />
          </div>
          <SidebarMenuSub>
            {project.threads.map((width) => (
              <li key={width} className="flex h-7 items-center px-2">
                <Skeleton className={cn("h-3", width)} />
              </li>
            ))}
          </SidebarMenuSub>
        </div>
      ))}
    </div>
  );
}
